import React from 'react';
import classNames from 'classnames';

import { YatLevelDesignation } from '../../types';

import { Emoji } from './components';
import type { EmojiProps } from './components';

import './Pin.scss';

export interface PinProps {
    // TODO: We should also type this for `min` and `max` number.
    emojis: EmojiProps['id'][];
    level?: YatLevelDesignation;
}

export function Pin({ emojis, level = YatLevelDesignation.Common }: PinProps) {
    const pinClassNames = classNames('YatBadge-Pin', {
        // TODO: These should be simplified using a `variationName` utility.
        levelLegendary: level === YatLevelDesignation.Legendary,
        levelEpic: level === YatLevelDesignation.Epic,
    });

    const emojiItems = emojis.map((emoji, index) => (
        <Emoji key={`Pin-Emoji-${index}`} id={emoji} level={level} listItem />
    ));

    return (
        <div className={pinClassNames}>
            <div className="YatBadge-Pin-Interior">
                <ul className="YatBadge-Pin-List">{emojiItems}</ul>
            </div>
        </div>
    );
}
